import "core-js/modules/es.array.concat.js";
/* eslint-disable no-shadow */
export var Platform = /*#__PURE__*/function (Platform) {
  Platform["Mobile"] = "Mobile";
  Platform["Desktop"] = "Desktop";
  return Platform;
}({});
export var Reason = /*#__PURE__*/function (Reason) {
  Reason["InvalidField"] = "Invalid field";
  Reason["EmptyField"] = "Empty field";
  return Reason;
}({});
export var CefEventName = /*#__PURE__*/function (CefEventName) {
  CefEventName["Completed"] = "Completed";
  CefEventName["ClickedShowResult"] = "Clicked show results";
  CefEventName["ClickedShowResultTitlecase"] = "Clicked Show Results";
  CefEventName["ClickedStartOver"] = "Clicked start over";
  CefEventName["ClickedApplyNow"] = "Clicked apply now";
  CefEventName["ClickedFindOutWhy"] = "Clicked find out why";
  CefEventName["ClickedEditEligibility"] = "Clicked edit eligibility";
  CefEventName["ClickedExploreOtherPrograms"] = "Clicked explore other programs";
  CefEventName["ClickedCheckEligibility"] = "Clicked check eligibility";
  CefEventName["ClickedTalkToAdvisorLink"] = "Clicked talk to advisor link";
  CefEventName["ClickedSaveAndExit"] = "Saved and exited";
  CefEventName["ClickedExitWithoutSaving"] = "Exited without saving";
  CefEventName["ClickedContinueWhereLeftOff"] = "Continued where left off";
  CefEventName["ClickedRestartProgress"] = "Restarted progress";
  CefEventName["ClickedShowResultOnSearch"] = "Clicked Show Result on Search Page";
  CefEventName["ClickedNotEligible"] = "Clicked not eligible";
  CefEventName["ClickedNoIntake"] = "Clicked no intake";
  CefEventName["ClickedGoToApplication"] = "Clicked go to application";
  CefEventName["FailedToNavigateToNextStep"] = "Failed to navigate to next step";
  CefEventName["Started"] = "Started";
  CefEventName["CancelledEligibilityCheck"] = "Cancelled eligibility check";
  return CefEventName;
}({});
export var CefEvent = function CefEvent(event, platform, data) {
  return {
    event: "CEF - ".concat(platform, " - ").concat(event),
    data: data
  };
};